import React from 'react'
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'

import Home from './pages/Home/Starter'
import Yoga from './pages/Yoga/Yoga'
// eslint-disable-next-line
import About from './pages/About/About'
import Tutorials from './pages/Tutorials/Tutorials'


import CounterPage from "./pages/CounterPage"
import Counter from "./counter";

import './App.css'

export default function App() {
  return (
    <Router>
      <Routes>
      
        <Route exact path='/' element={<Home />}/>
        <Route path='/start' element={<Yoga />} />

        <Route path='/tutorials' element={<Tutorials />} />
        <Route path='/counter' element={<CounterPage />} /> 

      <Route path='/bicepcurls'> <Counter exercise={"bicepCurls"} /> </Route>
      <Route path='/squats'> <Counter exercise={"squats"} /> </Route>
      <Route path='/pushups'> <Counter exercise={"pushups"} /> </Route>
      <Route path='/crunches'> <Counter exercise={"crunches"} /> </Route> 

      </Routes>
    </Router>
  
  )
}


